import Api from '@/vuex/api'
import {
  CURRENT_DATABASE_SEARCH,
  DELETE_DATABASE_OBJECT,
  EDIT_DATABASE_OBJECT,
  LOAD_DATA,
  LOAD_DIRECTORY,
  NEW_DATABASE_OBJECT,
  OPEN_MODAL,
  UPLOAD_APP_ICON
} from '@/vuex/types'

const api = new Api()

const state = {
  databaseManager: {
    databases: [{
      name: 'Apps',
      path: 'apps',
      admin: true
    }, {
      name: 'Roscon Staff',
      path: 'staff',
      admin: true
    }, {
      name: "Roscon Staff Tax Invoice Report",
      path: "staff-tax-invoice-report",
      admin: true,
    },
    {
      name: "24/7 EPMA Contracts",
      path: "epma",
      admin: true,
    },
     {
      name: 'Companies',
      path: 'companies',
      admin: true
    }, {
      name: 'Generate Stats for All Companies',
      path: 'all-company-stats',
      admin: true,
    }, {
      name: 'Contractors',
      path: 'contractors',
      admin: true
    }, {
      name: 'OH&S Hazard Locations',
      path: 'ohs-locations-db'
    }, {
      name: 'OH&S Hazard Findings / Recommendations',
      path: 'ohs-findings-db'
    }, {
      name: 'ESM Items',
      path: 'esm-items-db'
    }, {
      name: 'ESM Templates',
      path: 'esm-templates-db'
    }],
    propertyDataManagement: [{
      name: 'Owners Corporation Managers',
      path: 'oc-managers',
      admin: true
    }, {
      name: 'Properties',
      path: 'properties'
    }, {
      name: 'Properties (Excel Uploader)',
      path: 'properties-excel'
    }, 
    {
      name: 'OC Managers Feed',
      path: 'oc-managers-feed'
    }, {
      name: 'Property Costing',
      path: 'property-costing'
    }],
    clientQuotes: [{
      name: 'Quote Settings',
      path: 'report-info',
      admin: true
    }, {
      name: 'Videos',
      path: 'quote-videos',
      admin: true
    }],
    invoicing: [{
      name: 'Invoice Account Codes',
      path: 'invoice-codes'
    }],
    general: [{
      name: 'Edit Settings',
      path: 'settings',
      admin: true
    }, {
      name: 'Roscon Website Media Items',
      path: 'media-items',
      admin: true
    }]
  },
  databaseItems: {
    columns: [],
    count: 0,
    permalink: false,
    rows: [],
    links: [],
    noResults: '',
    offset: 0,
    limit: 20,
    searchForm: {
      fields: []
    }
  },
  directory: [],
  currentDatabaseSearch: {}
}

const getters = {
  $databaseManager: ({ databaseManager }) => (user) => {
    if (user.loggedIn && !user.administrator) {
      for (let key in databaseManager) {
        databaseManager[key] = databaseManager[key].filter(el => !el.admin)
      }
    }
    return databaseManager
  },
  databaseItems ({ databaseItems }) {
    return databaseItems
  },
  databaseSearchForm ({ databaseItems }) {
    return databaseItems.searchForm
  }
}

const mutations = {
  [LOAD_DATA] (context, databaseItems) {
    databaseItems.searchForm.fields.push({
      type: 'text',
      label: 'Results Per Page',
      name: 'limit',
      fullWidth: true,
      value: databaseItems.limit.toString()
    })
    context.databaseItems = databaseItems
  },
  [CURRENT_DATABASE_SEARCH] (context, options) {
    context.currentDatabaseSearch = options
  },
  [LOAD_DIRECTORY] (context, directory) {
    context.directory = directory
  }
}

const actions = {
  async [LOAD_DIRECTORY] (context) {
    let data = await api.getDirectory()
    context.commit(LOAD_DIRECTORY, data)
  },
  async [LOAD_DATA] (context, options) {
    if (!options) {
      options = context.state.currentDatabaseSearch
    }
    let data = await api.getDatabaseItems(options)
    context.commit(LOAD_DATA, data)
    context.commit(CURRENT_DATABASE_SEARCH, options)
  },
  async [EDIT_DATABASE_OBJECT] (context, payload) {
    let editModal = {
      permalink: payload.permalink,
      options: {
        title: 'Edit',
        actionLabel: 'Save'
      },
      params: {
        uuid: payload.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editModal)
  },
  async [DELETE_DATABASE_OBJECT] (context, payload) {
    let deleteModal = {
      permalink: payload.permalink,
      options: {
        title: 'Delete',
        actionLabel: 'Delete'
      },
      params: {
        uuid: payload.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteModal)
  },
  async [NEW_DATABASE_OBJECT] (context, permalink) {
    let newModal = {
      permalink,
      options: {
        title: 'New',
        actionLabel: 'Save'
      }
    }
    context.dispatch(OPEN_MODAL, newModal)
  },
  async [UPLOAD_APP_ICON] (context, appUuid) {
    let uploadModal = {
      permalink: 'uploadAppIcon',
      options: {
        title: 'Upload App Icon',
        actionLabel: 'Save'
      },
      params: {
        appUuid
      }
    }
    context.dispatch(OPEN_MODAL, uploadModal)
  }
}

export default {
  actions,
  getters,
  mutations,
  state
}




// WEBPACK FOOTER //
// ./src/vuex/modules/database.js